export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            你有猛料？欢迎投稿，让我们一起来完善吃瓜版图
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-500"></i>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 mb-1">投稿邮箱</h3>
              <p className="text-xs text-foreground-500">tips@heiliao.example.com</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className="ri-wechat-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 mb-1">微信客服</h3>
              <p className="text-xs text-foreground-500">heiliao_chigua</p>
            </div>
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
                <i className="ri-time-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-medium text-sm text-foreground-900 mb-1">响应时间</h3>
              <p className="text-xs text-foreground-500">工作日 24 小时内回复</p>
            </div>
          </div>

          <div className="border-t border-background-200 pt-6">
            <p className="text-xs text-foreground-400 text-center">
              投稿前请阅读：我们欢迎真实爆料，拒绝恶意造谣、人身攻击和侵犯隐私的内容。请尽量附带来源线索或截图，以提高采纳率。所有投稿均会经过编辑审核后酌情发布。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}